import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Footer from './components/footer';
import Navbar from './components/navbar';

import Home from './pages/home';
import Login from './pages/login';
import GuildProfile from './pages/guild-profile';
import UserProfile from './pages/user-profile';
import ChannelProfile from './pages/channel-profile';
import Game from './pages/game';

const Layout = ({ children }) => (
    <>
        <Navbar />
            {children}
        <Footer />
    </>
);

const RoutesComponent = () => (
    <Routes>
        <Route path="/c/:platform/:channel" element={<Layout><ChannelProfile /></Layout>} />
        <Route path="/u/:userId/profile" element={<Layout><UserProfile /></Layout>} />
        <Route path="/g/:discordServerId" element={<Layout><GuildProfile /></Layout>} />
        <Route path="/g/:discordServerId/game/:gameId" element={<Game />} />
        <Route path="/login" element={<Layout><Login /></Layout>} />
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="*" element={<Layout><div>404 Not Found</div></Layout>} />
    </Routes>
);

export default RoutesComponent;
 